<template>
  <div :class="['bookable-details', `count${details.length}`]">
    <slot name="txtBefore"></slot>
    <div class="bookable-details-item" v-for="detail in details_" v-bind:key="detail.primary + detail.secondary">
      <span v-html="detail.primary" class="bookable-details-item-primary"></span>
      <span v-html="detail.secondary" class="bookable-details-item-secondary">{{detail.secondary}}</span>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>
export default {
  name: 'BookableDetails',
  props: {
    /**
     * provide array with objects of following attributes
     * - primary: the first line of the box, usually displayed in bigger font size
     * - secondary: the seconds line of the box, usually displayed in smaller font size
     */
    details: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    details_ () {
      return this.details.filter(function (x) {
        return x !== undefined
      })
    }
  }
}
</script>
